const PageNotFound = () => import(/* webpackChunkName: "login" */ '@/views/errors/PageNotFound.vue')

/* Guest Pages */
const Login = () => import(/* webpackChunkName: "login" */ '@/views/guest/Login.vue')

/* Authenticated Pages */
const Routers = () => import(/* webpackChunkName: "routers" */ '@/views/auth/Routers.vue')
const Bands = () => import(/* webpackChunkName: "bands" */ '@/views/auth/Bands.vue')

export default [
	...middleware('guest', [
		{
			path: '/',
			name: 'login',
			component: Login
		}
	]),

	...middleware('auth', [
		{
			path: '/routers',
			name: 'routers',
			component: Routers
		},

		{
			path: '/bands/:id',
			name: 'bands',
			props: true,
			component: Bands,
			meta: {
				home: 'routers'
			}
		}
	]),

	...middleware('*', [
		{
			path: '*',
			name: 'PageNotFound',
			component: PageNotFound
		}
	])
]

function middleware (middleware, routes) {
	// setting middleware for every route
	routes.forEach(route => {
		if (route.children) {
			route.children.forEach(child => { child.meta = { ...child.meta, middleware } })
		}

		route.meta = {
			...route.meta,
			middleware
		}
	})

	return routes
}
